import * as React from 'react';
import { ReeferCommandsGrid } from '../../childcomponents/ReeferCommandsGrid';
import { PopupWindow } from '../../sharedcomponents/PopupWindow';
import * as RCNGWindow from '../../sharedcomponents/ConfirmationWindow';
import { RCUtils } from '../../../RCUtils';
import $ from 'jquery';
var Config: any = require('../../../Config.json');

interface VCCheckBoxData {
    enableVCCheckBox: boolean;
    disableVCCheckBoxOption: boolean;
    disableVCDropDown: boolean;
    disableVCOption: boolean;
    selectedVCData: server.VesselInformation;
    dropDownVCData: server.VesselInformation[];
    isVCMessage: boolean;
}

const emptyVCCheckBoxData: VCCheckBoxData = { enableVCCheckBox: false, disableVCCheckBoxOption: false, disableVCDropDown: false, disableVCOption: false, selectedVCData: null, dropDownVCData: [], isVCMessage: false };

interface atmosphereState {
    SelectedReefers: any[];
    O2Value: string;
    CO2Value: string;
    RowData: server.USP_UnitCurrentConditionUI_Model[];
    Filters: server.ForwardCommandParameters;
    VCCheckBoxInfo: VCCheckBoxData;
    isStarCoolOem: boolean;
    O2List: any[];
    Co2List: any[];
    activeApplicationValue: string;
    CAModeValue: string;
    IsCommandIssued: boolean;
    PrevSelectedItems: any[];
}

var self;

export class ControlledAtmosphere extends React.Component<any, atmosphereState> {
    constructor(props: any) {
        super(props);
        $('#globalLoader').show();
        var filterSet = this.setDefaultFilters();
        this.state = { SelectedReefers: [], O2Value: "", CO2Value: "", RowData: [], Filters: filterSet, VCCheckBoxInfo: emptyVCCheckBoxData, isStarCoolOem: this.props.starCoolOem, O2List: [], Co2List: [], activeApplicationValue: '', CAModeValue: '', IsCommandIssued: false, PrevSelectedItems: []  };
        self = this;
    }

    loadO2CO2DefaultValues() {
        var o2Value = '1,1.5,2,2.5,3,3.5,4,4.5,5,5.5,6,6.5,7,7.5,8,8.5,9,9.5,10,11,12,13,14,15,16,17,18,19,20,21';
        var co2Value = '1,1.5,2,2.5,3,3.5,4,4.5,5,5.5,6,6.5,7,7.5,8,8.5,9,9.5,10,11,12,13,14,15,16,17';
        this.setState({ O2List: o2Value.split(','), Co2List: co2Value.split(',') });
    }

    setDefaultFilters() {
        var filters: server.ForwardCommandParameters = {
            SelectedReefers: [], CommandName: "SetControlledAtmosphere", TempValue: "", OtherValue: null, IsCmdSendViaVC: null, VesselInfo: null
        };

        return filters;
    }

    UpdateVCCheckBoxInfo(VCInfo: any) {
        if (this.props.UpdateVCCheckBoxInfo != null && this.props.UpdateVCCheckBoxInfo != 'undefined')
            this.props.UpdateVCCheckBoxInfo(VCInfo);
    }

    componentDidMount() {
        if (this.props.reeferData != null && this.props.reeferData.length > 0) {
            this.setState({ RowData: this.props.reeferData });
            this.renderSetPointGrid(this.props.reeferData);
        }

        if (this.props.VCCheckBoxInfo != undefined && this.props.VCCheckBoxInfo != null) {
            this.setState({ VCCheckBoxInfo: this.props.VCCheckBoxInfo });
        }

        if (!this.state.isStarCoolOem)
            this.setState({ CAModeValue: 'OFF' }, () => this.loadO2CO2DefaultValues());
        else
            this.setState({ activeApplicationValue: 'Standard' }, () => this.loado2Co2Values("Standard"));

        $('#globalLoader').hide();
    }

    componentWillReceiveProps(nextprops: any) {
        var reeferData = nextprops.reeferData;
        if (reeferData != undefined && reeferData != null && reeferData.length > 0) {
            $('#globalLoader').show();
            this.renderSetPointGrid(reeferData);
        }

        if (!nextprops.starCoolOem)
            this.setState({ isStarCoolOem: nextprops.starCoolOem, CAModeValue: 'OFF' }, () => this.loadO2CO2DefaultValues());
        else
            this.setState({ isStarCoolOem: nextprops.starCoolOem, activeApplicationValue: 'Standard' }, () => this.loado2Co2Values("Standard"));

        if (nextprops.VCCheckBoxInfo != undefined && nextprops.VCCheckBoxInfo != null) {
            this.setState({ VCCheckBoxInfo: nextprops.VCCheckBoxInfo });
        }
    }

    O2Change(event: React.FormEvent<HTMLSelectElement>) {
        var o2Val = this.state.O2Value;
        var Value: string = event.currentTarget.value.trim();
        //const IsMatch = /^[-+]?[0-9]*\.?[0-9]*([eE][-+]?[0-9]+)?$/;
        //if (IsMatch.test(Value))
        //    o2Val = Value;
        //else
        //    return;
        this.setState({ O2Value: Value });
    }

    CO2Change(event: React.FormEvent<HTMLSelectElement>) {
        var co2Val = this.state.CO2Value;
        var Value: string = event.currentTarget.value.trim();
        //const IsMatch = /^[-+]?[0-9]*\.?[0-9]*([eE][-+]?[0-9]+)?$/;
        //if (IsMatch.test(Value))
        //    co2Val = Value;
        //else
        //    return;
        this.setState({ CO2Value: Value });
    }

    renderSetPointGrid(reeferData: any) {
        this.setState({ RowData: reeferData, O2Value: '', CO2Value: '' });
        this.state.Filters.CommandName = "SetControlledAtmosphere";
        this.state.Filters.SelectedReefers = reeferData;
        var forwardCommandParams = JSON.stringify(this.state.Filters);
        var request = RCUtils.FetchRequest(Config.ApiBaseUrl + '/api/reeferstatus/GetForwardCommandData', { method: 'POST', body: forwardCommandParams, headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' } });
        fetch(request)
            .then(RCUtils.handleError)
            .then(response => response.json() as Promise<server.USP_UnitCurrentConditionUI_Model[]>)
            .then(data => {
                this.setState({ RowData: data });
                $('#globalLoader').hide();
            });
    }

    submitCommand() {
        var command = "SetControlledAtmosphere";
        var paramValue = this.state.O2Value + ',' + this.state.CO2Value + ',' + this.state.activeApplicationValue;
        var refreshGrid = this.props.refreshGrid;
        ReeferCommandsGrid.submitTemperatureCommands(command, paramValue, refreshGrid); 
        this.setState({ IsCommandIssued: true, PrevSelectedItems: this.props.reeferData }, () => { this.props.IsCommandIssued(this.state.IsCommandIssued); this.props.PrevSelectedItems(this.props.reeferData) });
    }

    closeConfirmation() {
        RCNGWindow.ConfirmWindow.close();
    }

    submitPoints() {
        if (this.state.isStarCoolOem) {
            var messageString = "<span class='color-red'>Due to regulation of the cargo atmosphere, the oxygen level may be low and/or the carbon dioxide level high inside the container!  All personnel must check gas levels and flush with fresh air before entering/unloading.  <b> Exposure to low oxygen/high carbon dioxide may cause loss of consciousness and suffocation.</b></span>";
            RCNGWindow.ConfirmWindow.showConfirmBoxWithWarning(messageString, this.submitCommand.bind(this), this.closeConfirmation.bind(this));
        }
        else {
            if ((this.state.O2Value != null && this.state.O2Value != undefined && this.state.O2Value != '') && (this.state.CO2Value != null && this.state.CO2Value != undefined && this.state.CO2Value != '')) {
                var command = '';
                if (this.state.CAModeValue == 'ON')
                    command = "SetControlledAtmosphereMode";
                else
                    command = "SetControlledAtmosphere";
                var paramValue = this.state.O2Value + ',' + this.state.CO2Value + ',' + this.state.CAModeValue;
                var refreshGrid = this.props.refreshGrid;
                ReeferCommandsGrid.submitTemperatureCommands(command, paramValue, refreshGrid);
            }
            else {
                PopupWindow.showErrorMessage("Alert", "Please select O2 and CO2 values.");
            }
        }
    }

    activeApplicationChange(event: React.FormEvent<HTMLSelectElement>) {
        $('#globalLoader').show();
        var applicationValue = event.currentTarget.value.trim();
        this.setState({ activeApplicationValue: applicationValue });
        self.loado2Co2Values(applicationValue);
    }

    CAModeChange(event: React.FormEvent<HTMLSelectElement>) {
        var CAModeValueSelected = event.currentTarget.value.trim();
        this.setState({ CAModeValue: CAModeValueSelected });
    }

    loado2Co2Values(applicationValue: string) {
        var o2Value = '';
        var co2Value = '';
        var o2DefaultValue = '';
        var co2DefaultValue = '';

        switch (applicationValue) {
            case "Standard":
                o2Value = '0';
                co2Value = '0';
                o2DefaultValue = '0';
                co2DefaultValue = '0';
                break;
            //case "1":
            //    o2Value = '1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19';
            //    co2Value = '0,1,2,3,4,5,6,7,8,9,10,11,12';
            //    break;
            case "AVPlus":
                o2Value = '0,1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19';
                co2Value = '0,1,2,3,4,5,6,7,8,9,10,11,12';
                o2DefaultValue = '0';
                co2DefaultValue = '0';
                break;
            case "CA":
                o2Value = '3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21';
                co2Value = '4,5,6,7,8,9,10,11,12';
                o2DefaultValue = '3';
                co2DefaultValue = '4';
                break;
        }

        this.setState({ O2List: o2Value.split(','), Co2List: co2Value.split(','), O2Value: o2DefaultValue, CO2Value: co2DefaultValue}, () => $('#globalLoader').hide());
    }

    //onOkClick() {
    //    this.submitCommand();        
    //}

    //onCancelClick() {
    //    $('#warningOxygen').hide();
    //}

    public render() {
        return <div>
            <div className="modal-controls-container">
                {this.state.isStarCoolOem ?
                    <div>
                        <div className='row'>
                            <div className='col-lg-2 col-md-2 pe-0 text-md-end'>
                                <span className='float-end col-form-label'>Active Application :</span>
                            </div>
                            <div className='col-lg-2 col-md-4'>
                                <select className="form-select" id="ddlActiveApplication" onChange={e => this.activeApplicationChange(e)} value={this.state.activeApplicationValue}>                                    
                                    <option value="Standard">Standard</option>
                                    <option value="AVPlus">AV+</option>
                                    <option value="CA">CA</option>
                                </select>
                            </div>
                            <div className='col-lg-2 col-md-2 pe-0 text-md-end'>
                                <span className='float-end col-form-label'>Select O2 value :</span>
                            </div>
                            <div className='col-lg-2 col-md-4'>
                                <select className="form-select" id="ddlO2" onChange={e => this.O2Change(e)} value={this.state.O2Value}>
                                    {
                                        this.state.O2List.map((val, index) =>
                                            <option key={index} value={val}>{val == '0' ? 'OFF' : val}</option>
                                        )}
                                </select>
                            </div>
                            <div className='col-lg-2 col-md-2 pe-0 text-md-end'>
                                <span className='float-end col-form-label'>Select CO2 value :</span>
                            </div>
                            <div className='col-lg-2 col-md-4'>
                                <select className="form-select" id="ddlCO2" onChange={e => this.CO2Change(e)} value={this.state.CO2Value}>
                                    {
                                        this.state.Co2List.map((val, index) =>
                                            <option key={index} value={val}>{val == '0' ? 'OFF' : val}</option>
                                        )}
                                </select>
                            </div>
                        </div>
                      
                    </div>
                    :
                    <div className='row'>
                        <div className='col-lg-1 pe-0 text-md-end'>
                            <span className='float-end col-form-label'>CA Mode :</span>
                        </div>
                        <div className='col-lg-2'>
                            <select className="form-select" id="ddlCAMode" onChange={e => this.CAModeChange(e)} value={this.state.CAModeValue}>
                                <option value="OFF">OFF</option>
                                <option value="ON">ON</option>
                            </select>
                        </div>
                        <div className='col-lg-2 pe-0 text-md-end'>
                            <span className='float-end col-form-label'>Select O2 value :</span>
                        </div>
                        <div className='col-lg-2'>
                            <select className="form-select" id="ddlO2" onChange={e => this.O2Change(e)} value={this.state.O2Value}>
                                <option>--Select--</option>
                                {
                                    this.state.O2List.map((val, index) =>
                                        <option key={index} value={val}>{val}</option>
                                    )}
                            </select>
                        </div>
                        <div className='col-lg-2 pe-0 text-md-end'>
                            <span className='float-end col-form-label'>Select CO2 value :</span>
                        </div>
                        <div className='col-lg-2'>
                            <select className="form-select" id="ddlCO2" onChange={e => this.CO2Change(e)} value={this.state.CO2Value}>
                                <option>--Select--</option>
                                {
                                    this.state.Co2List.map((val, index) =>
                                        <option key={index} value={val}>{val}</option>
                                    )}
                            </select>
                        </div>
                    </div>
                }
            </div>
            <ReeferCommandsGrid reeferFormatter={this.props.reeferFormatter} selectedReefers={this.state.RowData} ChangeO2andCo2Action={true} commandName={"SetControlledAtmosphere"} VCCheckBoxInfo={this.state.VCCheckBoxInfo} UpdateVCCheckBoxInfo={this.UpdateVCCheckBoxInfo.bind(this)}></ReeferCommandsGrid>
            <div className="modal-footer">
                {this.state.isStarCoolOem ?
                    <div className='ca-footer-text'><span className='fa fa-exclamation-circle warning-circle'></span><span className='text-warning warningCA-Text'>Please ensure that the temperature setpoint is a chill setpoint prior to setting the Active Application to “CA”.<span className='ms-1'> Otherwise, the command may fail.</span></span></div>
                    :
                    ''
                }
                <button type="button" className="btn btn-secondary" data-bs-dismiss="modal">Cancel</button>
                <button type="button" className="btn btn-primary" onClick={this.submitPoints.bind(this)}>Save</button>
               
            </div>            
        </div>
    }
}